import { render } from "./StudentAttendances.vue?vue&type=template&id=1f9a366e&scoped=true"
import script from "./StudentAttendances.vue?vue&type=script&lang=js"
export * from "./StudentAttendances.vue?vue&type=script&lang=js"

import "./StudentAttendances.vue?vue&type=style&index=0&id=1f9a366e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f9a366e"]])

export default __exports__